import y from "@babel/runtime/helpers/esm/objectSpread2";
import A from "@babel/runtime/helpers/esm/classCallCheck";
import C from "@babel/runtime/helpers/esm/createClass";
import f from "@babel/runtime/helpers/esm/assertThisInitialized";
import T from "@babel/runtime/helpers/esm/inherits";
import E from "@babel/runtime/helpers/esm/createSuper";
import a from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as P } from "@semcore/utils/lib/core/index";
import R, { sstyled as u, assignProps as k, Component as w } from "@semcore/core";
import o from "react";
import { Text as M } from "@semcore/typography";
import { Box as S } from "@semcore/flex-box";
import { Hint as O } from "@semcore/tooltip";
import W from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import B from "@semcore/utils/lib/addonTextChildren";
import F from "@semcore/utils/lib/logger";
import H from "@semcore/utils/lib/hasLabels";
import $ from "@semcore/utils/lib/enhances/resolveColorEnhance";
var V = (
  /*__reshadow_css_start__*/
  (P.insert(
    /*__inner_css_start__*/
    ".___SLink_15i81_gg_{display:inline-block;font-family:inherit;color:var(--intergalactic-text-link, #006dca);line-height:normal;position:relative;cursor:pointer;-webkit-text-decoration:none;text-decoration:none;border:0;padding:0;margin:0;box-shadow:none;-webkit-tap-highlight-color:transparent;outline:0;background:0 0;transition:color .15s ease-in-out}.___SLink_15i81_gg_:active,.___SLink_15i81_gg_:focus{outline:0;-webkit-text-decoration:none;text-decoration:none}@media (hover:hover){.___SLink_15i81_gg_:hover{outline:0;-webkit-text-decoration:none;text-decoration:none}}.___SLink_15i81_gg_::-moz-focus-inner{border:0;padding:0}.___SLink_15i81_gg_.__active_15i81_gg_,.___SLink_15i81_gg_:active{color:var(--intergalactic-text-link-hover-active, #044792)}@media (hover:hover){.___SLink_15i81_gg_:hover{color:var(--intergalactic-text-link-hover-active, #044792)}}.___SLink_15i81_gg_.__active_15i81_gg_ .___SText_15i81_gg_,.___SLink_15i81_gg_:active .___SText_15i81_gg_{border-color:currentColor}@media (hover:hover){.___SLink_15i81_gg_:hover .___SText_15i81_gg_{border-color:currentColor}}.___SLink_15i81_gg_.__enableVisited_15i81_gg_:visited{color:var(--intergalactic-text-link-visited, #8649e1)}@media (hover:hover){.___SLink_15i81_gg_.__enableVisited_15i81_gg_:visited:hover{color:var(--intergalactic-text-link-visited, #8649e1)}}.___SLink_15i81_gg_.__keyboardFocused_15i81_gg_{outline-color:var(--intergalactic-keyboard-focus-outline, rgba(0, 143, 248, 0.5));outline-style:solid;outline-width:3px}.___SLink_15i81_gg_.__visually-disabled_15i81_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3);cursor:default;pointer-events:none}.___SLink_15i81_gg_.__noWrapText_15i81_gg_{white-space:nowrap}.___SLink_15i81_gg_.__inline_15i81_gg_{display:inline}.___SAddon_15i81_gg_{display:inline-flex;justify-content:center;align-items:center;margin-bottom:var(--intergalactic-spacing-05x, 2px);vertical-align:middle;pointer-events:none}.___SLink_15i81_gg_ .___SAddon_15i81_gg_:not(:only-child):first-child{margin-right:var(--intergalactic-spacing-1x, 4px)}.___SLink_15i81_gg_ .___SAddon_15i81_gg_:not(:only-child):last-child{margin-left:var(--intergalactic-spacing-1x, 4px)}.___SText_15i81_gg_{border-bottom-width:1px;border-bottom-style:solid;border-color:transparent;transition:border-bottom-color .15s ease-in-out}.___SLink_15i81_gg_.__text-color_15i81_gg_{color:var(--text-color_15i81)}.___SLink_15i81_gg_.__text-color_15i81_gg_.__active_15i81_gg_,.___SLink_15i81_gg_.__text-color_15i81_gg_:active{color:var(--text-color_15i81);filter:brightness(.8)}@media (hover:hover){.___SLink_15i81_gg_.__text-color_15i81_gg_:hover{color:var(--text-color_15i81);filter:brightness(.8)}}@media (prefers-reduced-motion){.___SLink_15i81_gg_,.___SText_15i81_gg_{transition:none}}",
    "15i81_gg_"
  ), {
    __SLink: "___SLink_15i81_gg_",
    _keyboardFocused: "__keyboardFocused_15i81_gg_",
    "_visually-disabled": "__visually-disabled_15i81_gg_",
    _noWrapText: "__noWrapText_15i81_gg_",
    _inline: "__inline_15i81_gg_",
    __SAddon: "___SAddon_15i81_gg_",
    __SText: "___SText_15i81_gg_",
    _active: "__active_15i81_gg_",
    _enableVisited: "__enableVisited_15i81_gg_",
    "_text-color": "__text-color_15i81_gg_",
    "--text-color": "--text-color_15i81"
  })
), h = /* @__PURE__ */ function(d) {
  T(n, d);
  var l = E(n);
  function n() {
    var i;
    A(this, n);
    for (var e = arguments.length, r = new Array(e), _ = 0; _ < e; _++)
      r[_] = arguments[_];
    return i = l.call.apply(l, [this].concat(r)), a(f(i), "containerRef", /* @__PURE__ */ o.createRef()), a(f(i), "state", {
      ariaLabelledByContent: "",
      visibleHint: !1
    }), a(f(i), "handleMouseEnterOnlyAddon", function() {
      i.setState({
        visibleHint: !0
      });
    }), a(f(i), "handleMouseLeaveOnlyAddon", function() {
      i.setState({
        visibleHint: !1
      });
    }), i;
  }
  return C(n, [{
    key: "componentDidMount",
    value: function() {
      var e = this;
      process.env.NODE_ENV !== "production" && F.warn(this.containerRef.current && !H(this.containerRef.current), "'title' or 'aria-label' or 'aria-labelledby' are required props for links without text content", this.asProps["data-ui-name"] || n.displayName), this.asProps["aria-labelledby"] && setTimeout(function() {
        var r, _;
        e.setState({
          ariaLabelledByContent: (r = (_ = document.getElementById(e.asProps["aria-labelledby"])) === null || _ === void 0 ? void 0 : _.textContent) !== null && r !== void 0 ? r : ""
        });
      }, 0);
    }
  }, {
    key: "renderChildren",
    value: function() {
      var e = this.asProps, r = e.Children, _ = e.styles, t = e.addonLeft, s = e.addonRight;
      return u(_), /* @__PURE__ */ o.createElement(o.Fragment, null, t ? /* @__PURE__ */ o.createElement(v.Addon, {
        tag: t
      }) : null, B(r, v.Text, v.Addon), s ? /* @__PURE__ */ o.createElement(v.Addon, {
        tag: s
      }) : null);
    }
  }, {
    key: "renderOnlyAddons",
    value: function() {
      var e, r, _, t = this.asProps, s = t.styles, m = t.addonLeft, p = t.addonRight, g = t.title, c = t["aria-label"], b = t.keyboardFocused, x = this.state.visibleHint, L = (r = (_ = g ?? c) !== null && _ !== void 0 ? _ : this.state.ariaLabelledByContent) !== null && r !== void 0 ? r : "";
      return e = u(s), /* @__PURE__ */ o.createElement(v.Addon, {
        tag: O,
        title: L,
        timeout: [250, 50],
        visible: b || x
      }, m && /* @__PURE__ */ o.createElement(m, e.cn("AddonLeft", {})), p && /* @__PURE__ */ o.createElement(p, e.cn("AddonRight", {})));
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, r, _ = M, t = this.asProps, s = t.styles, m = t.noWrap, p = t.color, g = t.resolveColor, c = t.disabled, b = t.href, x = t.children;
      return r = u(s), /* @__PURE__ */ o.createElement(_, r.cn("SLink", y({}, k({
        role: "link",
        tabIndex: c ? -1 : 0,
        "use:href": c ? void 0 : b,
        "visually-disabled": c,
        "text-color": g(p),
        tag: "a",
        noWrapText: m,
        "use:noWrap": !1,
        ref: this.containerRef,
        __excludeProps: ["disabled", "aria-disabled"],
        onMouseEnter: this.handleMouseEnterOnlyAddon,
        onMouseLeave: this.handleMouseLeaveOnlyAddon
      }, e))), x !== void 0 ? this.renderChildren() : this.renderOnlyAddons());
    }
  }]), n;
}(w);
a(h, "displayName", "Link");
a(h, "defaultProps", {
  noWrap: !0
});
a(h, "style", V);
a(h, "enhance", [W(), $()]);
function N(d) {
  var l = arguments[0], n, i = S, e = d.styles;
  return n = u(e), /* @__PURE__ */ o.createElement(i, n.cn("SText", y({}, k({
    tag: "span"
  }, l))));
}
function D(d) {
  var l = arguments[0], n, i = S, e = d.styles;
  return n = u(e), /* @__PURE__ */ o.createElement(i, n.cn("SAddon", y({}, k({
    tag: "span"
  }, l))));
}
var v = R(h, {
  Text: N,
  Addon: D
});
export {
  v as default
};
